export const SET_SECTION_FILTERS = 'SET_SECTION_FILTERS';
export const UPDATE_SECTION_FILTER = 'UPDATE_SECTION_FILTER';
export const TOGGLE_ALL_SECTIONS = 'TOGGLE_ALL_SECTIONS';
export const SET_FILTER_COUNT = 'SET_FILTER_COUNT';

const initialState = {
    sectionNames: [], 
    filterCount: '',
};

const sectionFilterReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SECTION_FILTERS:
            return {
                ...state,
                sectionNames: action.payload,
            };

        case UPDATE_SECTION_FILTER:
            return {
                ...state,
                sectionNames: state.sectionNames.map((section, idx) =>
                    idx === action.payload.index
                        ? { ...section, checked: action.payload.checked }
                        : section
                ),
            };

        case TOGGLE_ALL_SECTIONS:
            return {
                ...state,
                sectionNames: state.sectionNames.map((section) => ({
                    ...section,
                    checked: action.payload,
                })),
            };
        case SET_FILTER_COUNT:
            return {
                ...state,
                filterCount: action.payload,
            };

        default:
            return state;
    }
};

export default sectionFilterReducer;